import { render, staticRenderFns } from "./folderpermissions.vue?vue&type=template&id=77791b52&scoped=true&"
import script from "./folderpermissions.vue?vue&type=script&lang=js&"
export * from "./folderpermissions.vue?vue&type=script&lang=js&"
import style0 from "./folderpermissions.vue?vue&type=style&index=0&id=77791b52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77791b52",
  null
  
)

export default component.exports